<qai-carousel>
  <!-- Card 1: Overall Score (always shown) -->
  <div qaiCarouselItem class="result-card">
    <app-result-overall-score
      [scoresArray]="scoresArray"
      [scoreOverall]="scoreOverall"
    />
  </div>
</qai-carousel>
